import React from "react";
import WarehousePage from "./WarehousePage";

export function WarehouseSingleOrderCreation(props) {
    return (
        <WarehousePage
            {...props}
            page="orderCreation"
        />
    );
}